import { Segment, Card, Header, Button, Icon } from 'semantic-ui-react';
import { weekdays } from 'src/components/helpers';
import moment from 'moment';
import { seminaryInfo } from './groupRegistration';
import { groupTitle } from 'src/pages/groups/groupsRegistration';

const getLeaderFullName = (leader) =>
  leader?.name ? `${leader.name} ${leader.lastName || ''}`.trim() : '';

const GroupSummary = (props) => {
  const { inputs, onRestart } = props;
  const ChurchGroup = inputs?.groupMember?.ChurchGroup;
  const params = props.match.params;
  const isCoupleLed = !!ChurchGroup?.coupleleadered;

  const attendantsNames = (
    <strong>
      {inputs.Attendants?.[0] &&
        `${inputs.Attendants?.[0].name} ${inputs.Attendants?.[0].lastName}`}
      {inputs.Attendants?.[1] &&
        ` y ${inputs.Attendants?.[1].name} ${inputs.Attendants?.[1].lastName}`}
      !
    </strong>
  );

  const maleLeaderName = getLeaderFullName(ChurchGroup?.maleLeader);
  const femaleLeaderName = getLeaderFullName(ChurchGroup?.femaleLeader);
  const leaderDisplayName = [maleLeaderName, femaleLeaderName].filter(Boolean).join(' y ');

  const leaderNames = (
    <>
      {isCoupleLed ? 'Los lideres son ' : 'El líder es '}
      <span style={{ fontWeight: 'bold' }}>{leaderDisplayName}</span>
    </>
  );

  const contactMessage = leaderDisplayName ? (
    <p style={{ margin: '20px 0' }}>
      {isCoupleLed ? 'Los líderes' : 'El líder'} de tu grupo, <strong>{leaderDisplayName}</strong>,
      se pondrá
      {isCoupleLed ? 'n' : ''} en contacto contigo en los próximos días para darte más detalles.
      ¡Estamos emocionados de que des este paso!
    </p>
  ) : (
    <p style={{ margin: '20px 0' }}>
      {isCoupleLed ? 'Los líderes' : 'El líder'} de tu grupo se pondrá
      {isCoupleLed ? 'n' : ''} en contacto contigo en los próximos días para darte más detalles.
      ¡Estamos emocionados de que des este paso!
    </p>
  );

  const restartButton = onRestart && (
    <div style={{ marginTop: 28 }}>
      <Button type="button" primary onClick={onRestart}>
        <Icon name="refresh" /> Finalizar
      </Button>
    </div>
  );

  if (inputs?.groupMember?.pending) {
    return (
      <Segment className="selectedGroup">
        <div>
          <Header as="h2"> {groupTitle(params)}</Header>
          <p>¡Hola {attendantsNames}</p>
          <p>
            Ya estas preinscrito al grupo: <strong>{ChurchGroup?.groupName}</strong>
          </p>
          {contactMessage}
          <p style={{ fontStyle: 'italic', fontSize: '14px' }}>
            Si crees que ha pasado mucho tiempo y el líder no te ha contactado, por favor
            contactanos para ayudarte.
          </p>
          {restartButton}
        </div>
      </Segment>
    );
  }
  return (
    <Segment className="selectedGroup">
      <div>
        <Header as="h2">{groupTitle(params)}</Header>
        <p style={{ fontSize: '25px', margin: '0 0 20px 0' }}>Hola {attendantsNames}</p>
        {(inputs.kind === 'Grupo_Seminario' || inputs.kindgroup === 'Grupo_Seminario') &&
          seminaryInfo(inputs.activityName, true)}
        <p>
          Grupo al que asistes: <strong>{ChurchGroup?.groupName}</strong>
        </p>
        <p>{leaderNames}</p>
        <Card.Content>
          <p>
            <strong>Dia: </strong>
            {weekdays[ChurchGroup?.dayOfWeek]}
          </p>
          <p>
            <strong>Hora: </strong>
            {moment(ChurchGroup?.time, 'HH:mm').format('hh:mm a z')}
          </p>
          <p>
            <strong>Lugar de reunión: </strong>
            {ChurchGroup?.address} - {ChurchGroup?.neighborhood}
          </p>
          <p>
            <strong>Categoría: </strong>
            {ChurchGroup?.activityName?.replace(/_/g, ' ')}
          </p>
        </Card.Content>
        {restartButton}
      </div>
    </Segment>
  );
};

export default GroupSummary;
